<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-02-25 09:22:08
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <img src="@/assets/img/oks.png" alt="" />
    <div id="ok">{{$t('ok.title')}}</div>
    <div @click="gonew" class="loginButton">{{$t('ok.ok')}}</div>
  </div>
</template>

<script>
import { BinddeviceBindDevice } from '@/api/user'
export default {
  inject: ['getheader'],
  name: 'HelloWorld',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {},
  methods: {
    gonew () {
      let key = {
        equipment_id: localStorage.getItem('systemId'),
        type: localStorage.getItem('system') === 'iOS' ? 2 : 1
      }
      console.log(key)
      BinddeviceBindDevice(key).then(async (adj) => {
        await this.getheader()
        setTimeout(()=>{
          this.$router.push({ name: 'index' })
        },300)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  position: absolute;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.Take {
  font-size: 14px;
  color: grey;
  line-height: 20px;
  margin-left: 5%;
  width: 85%;
  max-width: 800px;
}
img {
  display: block;
  width: 64px;
  margin: 120px auto 0;
}
#ok {
  font-size: 16px;
  color: #000927;
  font-weight: 700;
  width: 300px;
  text-align: center;
  margin: 20px auto 0;
  font-family: Noto Sans;
}
.loginButton {
  width: 280px;
  height: 44px;
  line-height: 44px;
  font-size: 15px;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/ok.vue